// extracted by css-extract-rspack-plugin
export default {"stores":"StoreButtons-module__stores","store":"StoreButtons-module__store","text":"StoreButtons-module__text","small":"StoreButtons-module__small","big":"StoreButtons-module__big"};